export default __webpack_public_path__ + "static/media/Purple-Planet.4afa475c.svg";